import { useState, useContext } from 'react'
import { FiLogIn } from 'react-icons/fi'
import Input from "../../../shared/components/form/input"
/* CSS */
import './login.css'

/* img */
import logo from '../../../shared/img/logo.png'
import logoDeltabyte from '../../../shared/img/logo-deltabyte.png'
import loginImg from '../img/imagem_login.jpeg'


/* contexts */
import { Context } from '../../../context/UserContext'


function Login() {
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(false)
  const { login } = useContext(Context)

  function handleChange(e) {
    setUser({ ...user, [e.target.name]: e.target.value })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    await login(user)
    setLoading(false)
  }

  return (
    <section className="login-split">
      <div className="login-image-side" style={{ backgroundImage: `url(${loginImg})` }}>
        <div className="login-image-overlay" />
        <div className="login-image-content">
          <p className="login-image-title">Manutenção de geradores, sem complicação</p>
          <p className="login-image-brand">Best Force Geradores &amp; Energia Renovável</p>
          <p className="login-image-subtitle">Manutenção preventiva e corretiva de geradores. Peças de reposição. Plantão 24 horas.</p>
        </div>
      </div>

      <div className="login-form-side">
        <div className="login-form-box">
          <img className='login-logo' src={logo} alt="BestForce" />

          <p className="login-title">Bem-vindo de volta</p>
          <p className="login-subtitle">Entre com sua conta para continuar</p>

          <form onSubmit={handleSubmit} className='login-form'>
            <div className="form-group">
              <Input
                text="Usuário"
                type="text"
                name="userName"
                placeholder="Digite o seu usuário"
                handleOnChange={handleChange}
                value={user.userName || ''}
              />
            </div>
            <div className="form-group">
              <Input
                text="Senha"
                type="password"
                name="password"
                placeholder="Digite a sua senha"
                handleOnChange={handleChange}
                value={user.password || ''}
              />
            </div>

            <button className="login-submit-btn" type="submit" disabled={loading}>
              <FiLogIn size={16} />
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <a
          className="login-by"
          href="https://deltabyte.com.br"
          target="_blank"
          rel="noopener noreferrer"
          title="Conheça a Deltabyte"
        >
          <span className="login-by-text">Desenvolvido por</span>
          <img className="login-by-logo" src={logoDeltabyte} alt="Deltabyte" />
        </a>
      </div>
    </section>
  )
}

export default Login
